<template>
  <!-- <div :class="modalTheme"> -->
  <div :class="userStore.filterClass">
    <!-- <h6>xx modalTheme: {{ modalTheme }}</h6> -->

    <div style="background: transparent; padding: 3px">
      <h4 v-if="AreIdsShown" style="background: blue">AreIdsShown {{ AreIdsShown }}</h4>
      <h4 v-if="AreIdsShown" style="background: blue" v-b-toggle.widgetCharts>WidgetCharts</h4>

      <WidgetPriorityFiltersPrimary />

      <h5 v-if="AreIdsShown" style="background: blue">widgetType : {{ workListStore.currentSelectedSummaryWidget.widgetType }}</h5>

      <WidgetDoughnutChart
        v-if="workListStore.currentSelectedSummaryWidget.widgetType === 0"
        :widgetType="workListStore.currentSelectedSummaryWidget.widgetType"
        :widget="workListStore.currentSelectedSummaryWidget"
        :widgetDetail="workListStore.currentSelectedSummaryWidget.dueTextSummary"
      />
      <WidgetPieChart
        v-if="workListStore.currentSelectedSummaryWidget.widgetType === 1"
        :widgetType="workListStore.currentSelectedSummaryWidget.widgetType"
        :widget="workListStore.currentSelectedSummaryWidget"
        :widgetDetail="workListStore.currentSelectedSummaryWidget.dueTextSummary"
      />
      <WidgetBarChart
        v-if="workListStore.currentSelectedSummaryWidget.widgetType === 2"
        :widgetType="workListStore.currentSelectedSummaryWidget.widgetType"
        :widget="workListStore.currentSelectedSummaryWidget"
        :widgetDetail="workListStore.selectedWidgetDetail"
      />

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { useStoreWorkList } from "@/stores/workListsStore";

import WidgetPriorityFiltersPrimary from "@/components/WidgetPriorityFiltersPrimary.vue";

import WidgetDoughnutChart from "./WidgetDoughnutChart.vue";
import WidgetPieChart from "./WidgetPieChart.vue";
import WidgetBarChart from "./WidgetBarChart.vue";

// import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";

const workListStore = useStoreWorkList();
const AreIdsShown = ref(false);
const isOpen = ref(false); // closed by default

// * a computed ref
// const dueTextSummaryLength = computed(() => {
//   return workListStore.currentSelectedSummaryWidget.dueTextSummary.length > 0
// });
const modalTheme = computed(() => userStore.bModalTheme);

onMounted(() => {
  // console.log("onMounted() :      WidgetSummary CPNTAINER >>>>");
});
</script>

<style lang="scss" scoped>
@import "./worklistStyling.scss";

#pie {
  height: 540px;
  background: #353535;
  color: lightgoldenrodyellow;
}

.custom-resizer {
  width: 100%;
  height: 400px;
}

.custom-resizer > .pane {
  text-align: left;
  padding: 15px;
  overflow: hidden;
  background: #eee;
  border: 1px solid #ccc;
}

.custom-resizer > .multipane-resizer {
  margin: 0;
  left: 0;
  position: relative;

  &:before {
    display: block;
    content: "";
    width: 3px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -1.5px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }

  &:hover {
    &:before {
      border-color: #999;
    }
  }
}

.dx-toolbar .dx-toolbar-items-container {
  height: 0rem !important;
}

.scroll-container,
.scroll-area {
  //max-width: 150px;
  height: 45px * 2;
  max-height: 45px * 4;
  //font-size: 30px;32
}

.scroll-container {
  overflow: auto;
  scroll-snap-type: y mandatory;
}

.scroll-area {
  scroll-snap-align: start;
}

.detailsSlot {
  border: 3px solid transparent;
}

.scroll-container,
.scroll-area {
  margin: 0 auto;
}

.scroll-area {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.scroll-area:nth-of-type(1) {
  background: #49b293;
}

.scroll-area:nth-of-type(2) {
  background: #c94e4b;
}

.scroll-area:nth-of-type(3) {
  background: #4cc1be;
}

.scroll-area:nth-of-type(4) {
  background: #8360a6;
}

h2 {
  color: red;
  background: #9aa99b;
  border-radius: 12.5px;
}

.multipane.foo.layout-v .multipane-resizer {
  margin: 0;
  left: 0;
  /* reset default styling */
  width: 15px;
  background: transparent;
}

.multipane.foo.layout-h .multipane-resizer {
  margin: 0;
  top: 0;
  /* reset default styling */
  height: 15px;
  background: blue;
}
</style>
